<template>
  <div class="start-time-filter">
    <UiCheckbox
      v-for="item in checkboxItems"
      :key="item.value"
      :label="item.label"
      :isChecked="item.checked"
      class="start-time-filter__checkbox"
      @inputValue="toggleValue(item.value)"
    >
      <template #hint>
        {{ item.description }}
      </template>
    </UiCheckbox>
  </div>
</template>

<script setup lang="ts">
  import { watch, ref } from 'vue';
  import { UiCheckbox } from '@experience/core-checkbox-ui';
  import { getStartTimeFilterItems } from './consts';
  import { type StartTimeValue } from '@/shared/types/basic.ts';
  import type { TExcursionStartTimeInterval } from '@/entities/filter/store/types/excursion/state';

  interface Props {
    filterItems: StartTimeValue[];
  }

  const props = defineProps<Props>();
  const emit = defineEmits<{ (e: 'apply', value: TExcursionStartTimeInterval): void }>();

  const { DAY, MORNING, EVENING, NIGHT } = getStartTimeFilterItems();

  const startTimeItemsList = [MORNING, DAY, EVENING, NIGHT];

  const checkedValues = ref(new Set(props.filterItems));

  const toggleValue = (value: StartTimeValue) => {
    if (checkedValues.value.has(value)) {
      checkedValues.value.delete(value);
    } else {
      checkedValues.value.add(value);
    }
    emit('apply', Array.from(checkedValues.value));
  };

  const checkboxItems = computed(() =>
    startTimeItemsList.map((item) => ({
      ...item,
      checked: checkedValues.value.has(item.value),
    })),
  );

  watch(
    () => props.filterItems,
    (newVal) => {
      checkedValues.value = new Set(newVal);
    },
  );
</script>

<style scoped lang="scss">
  .start-time-filter {
    margin-top: 8px;
  }

  .start-time-filter__checkbox {
    grid-template-columns: 20px 1fr;
    width: 100%;
    margin: 8px 0;
  }
</style>
